import { render, staticRenderFns } from "./TimetableItemParts.vue?vue&type=template&id=2a2b1f51&scoped=true"
import script from "./TimetableItemParts.vue?vue&type=script&lang=ts"
export * from "./TimetableItemParts.vue?vue&type=script&lang=ts"
import style0 from "./TimetableItemParts.vue?vue&type=style&index=0&id=2a2b1f51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b1f51",
  null
  
)

export default component.exports